import React from 'react';
import { AnswerType, QuestionType, ValueType } from '../generated-types';
import { getNameForSubQuestion } from '../util/field-name';
import HelpModal from '../util/helpModals/help-modal';
import { composeValidators, positiveNumbersOnly, requiredField } from '../util/validator';
import ListQuestionType from './list-question-type';
import SelectInput from './select-input';
import { StandardInputField } from './standard-input-field';
import { TextAreaInputField } from './text-area-input-field';
import YesNoSubQuestionType from './yes-no-sub-question-type';
const getSubDropDownValues = (question, countries) => {
  const dropDownValues = [{
    text: 'Velg',
    value: 'velg'
  }];
  if (question.valueType === ValueType.COUNTRY) {
    if (countries !== null && countries !== void 0 && countries.countries) {
      countries.countries.filter(country => !country.historicUseOnly).forEach(country => {
        dropDownValues.push({
          text: country.text,
          value: country.iso2
        });
      });
    }
  }
  return dropDownValues;
};
export const SubQuestionRenderer = _ref => {
  let {
    subQuestion,
    index,
    name,
    countries,
    setValueOfField,
    setInitialValueOfSpecialFields,
    validate
  } = _ref;
  switch (subQuestion.type) {
    case QuestionType.CHOICE_YES_NO:
      return /*#__PURE__*/React.createElement(YesNoSubQuestionType, {
        name: getNameForSubQuestion(name, index),
        key: subQuestion.id,
        subQuestion: subQuestion
      });
    case QuestionType.LIST:
      return /*#__PURE__*/React.createElement(ListQuestionType, {
        question: subQuestion,
        key: subQuestion.id,
        name: getNameForSubQuestion(name, index),
        setValueOfField: setValueOfField,
        countries: countries,
        setInitialValueOfSpecialFields: setInitialValueOfSpecialFields
      });
    case QuestionType.STRING:
      return /*#__PURE__*/React.createElement(StandardInputField, {
        name: getNameForSubQuestion(name, index),
        label: subQuestion.text,
        validate: composeValidators(value => validate ? validate(value === null || value === void 0 ? void 0 : value.answer) : ''),
        key: subQuestion.id,
        onChangeOverride: event => {
          return {
            answer: event.target.value,
            questionId: subQuestion.id,
            questionVersion: subQuestion.version,
            answerType: AnswerType.SINGLE
          };
        },
        overrideValueKey: "answer",
        infoButton: /*#__PURE__*/React.createElement(HelpModal, {
          questionId: subQuestion.id,
          helpText: subQuestion.helpText
        })
      });
    case QuestionType.AMOUNT:
      return /*#__PURE__*/React.createElement(StandardInputField, {
        type: "number",
        name: getNameForSubQuestion(name, index),
        label: subQuestion.text,
        key: subQuestion.id,
        validate: composeValidators(requiredField, value => positiveNumbersOnly(value.answer)),
        onChangeOverride: event => {
          return {
            answer: event.target.value,
            questionId: subQuestion.id,
            questionVersion: subQuestion.version,
            answerType: AnswerType.SINGLE
          };
        },
        overrideValueKey: "answer",
        infoButton: /*#__PURE__*/React.createElement(HelpModal, {
          helpText: subQuestion.helpText,
          questionId: subQuestion.id
        })
      });
    case QuestionType.DROP_DOWN:
      return /*#__PURE__*/React.createElement(SelectInput, {
        label: /*#__PURE__*/React.createElement("div", null, subQuestion.text, /*#__PURE__*/React.createElement(HelpModal, {
          helpText: subQuestion.helpText,
          questionId: subQuestion.id
        })),
        name: getNameForSubQuestion(name, index),
        values: getSubDropDownValues(subQuestion, countries),
        onChangeOverride: event => {
          return {
            questionId: subQuestion.id,
            questionVersion: subQuestion.version,
            answer: event.target.value,
            answerType: AnswerType.SINGLE,
            subQuestion: []
          };
        },
        overrideValueKey: "answer"
      });
    case QuestionType.TEXT_AREA:
      return /*#__PURE__*/React.createElement(TextAreaInputField, {
        label: /*#__PURE__*/React.createElement("div", null, subQuestion.text, /*#__PURE__*/React.createElement(HelpModal, {
          helpText: subQuestion.helpText,
          questionId: subQuestion.id
        })),
        name: getNameForSubQuestion(name, index),
        onChangeOverride: event => {
          return {
            questionId: subQuestion.id,
            questionVersion: subQuestion.version,
            answer: event.target.value,
            answerType: AnswerType.SINGLE,
            subQuestion: []
          };
        },
        overrideValueKey: "answer",
        validate: composeValidators(value => validate ? validate(value === null || value === void 0 ? void 0 : value.answer) : '')
      });
    default:
      return /*#__PURE__*/React.createElement("div", null, "".concat(subQuestion.text, " - ").concat(subQuestion.type, " (UNSUPPORTED)"));
  }
};